import { call, put, takeEvery } from 'redux-saga/effects';
import {
  GET_ZONES,
  ADD_ZONE,
  UPDATE_ZONE,
  DELETE_ZONE,
} from './actionTypes';
import {
  getZonesSuccess,
  getZonesFail,
  addZoneSuccess,
  addZoneFail,
  updateZoneSuccess,
  updateZoneFail,
  deleteZoneSuccess,
  deleteZoneFail,
} from './actions';
import axiosInstance from 'pages/Utility/axiosInstance';
import { showError, showSuccess } from 'helpers/notification_helper';

// ====================== API Calls ======================

const fetchZonesApi = () =>
  axiosInstance.get('', { params: { sp: 'usp_GetZones' } });

const addZoneApi = (zone) =>
  axiosInstance.post('', zone);

const updateZoneApi = (zone) =>
  axiosInstance.post('', zone);

const deleteZoneApi = (id) =>
  axiosInstance.post('', { sp: 'usp_DeleteZone', zoneId: id });

// ====================== Worker Sagas ======================

// Get Zones
function* getZonesSaga() {
  try {
    const { data } = yield call(fetchZonesApi);
    yield put(getZonesSuccess(data));
  } catch (error) {
    yield put(getZonesFail(error.response?.data || error.message));
  }
}

// Add Zone
function* addZoneSaga(action) {
  try {
    const { data } = yield call(addZoneApi, action.payload.zone);
    showSuccess("Zone Added Successfully");
    yield put(addZoneSuccess(data));
    yield put({ type: GET_ZONES }); 
  } catch (error) {
    yield put(addZoneFail(error.response?.data || error.message));
  }
}

// Update Zone
function* updateZoneSaga(action) {
  try {
    const { data } = yield call(updateZoneApi, action.payload.zone);
    showSuccess("Zone Updated Successfully");
    yield put(updateZoneSuccess(data));
    yield put({ type: GET_ZONES }); 
  } catch (error) {
    yield put(updateZoneFail(error.response?.data || error.message));
  }
}

// Delete Zone
function* deleteZoneSaga(action) {
  try {
    yield call(deleteZoneApi, action.payload);
    showSuccess("Zone Deleted Successfully");
    yield put(deleteZoneSuccess(action.payload));
    yield put({ type: GET_ZONES }); 
  } catch (error) {
    yield put(deleteZoneFail(error.response?.data || error.message));
  }
}

// ====================== Watcher Saga ======================
function* zoneSaga() {
  yield takeEvery(GET_ZONES, getZonesSaga);
  yield takeEvery(ADD_ZONE, addZoneSaga);
  yield takeEvery(UPDATE_ZONE, updateZoneSaga);
  yield takeEvery(DELETE_ZONE, deleteZoneSaga);
}

export default zoneSaga;
